import { Component, Input } from '@angular/core';
import { UntypedFormGroup } from '@angular/forms';

@Component({
  standalone: false,
  selector: 'mtn-email-address-field',
  templateUrl: './email-address-field.component.html',
  styleUrls: ['./email-address-field.component.scss']
})
export class EmailAddressFieldComponent {

  @Input()
  form: UntypedFormGroup;
  @Input()
  controlName: string = 'email';
  @Input()
  isRequired = false;
  @Input()
  placeholder: string = 'Email Address';

  constructor() {
  }

}
